module.exports = __webpack_public_path__ + "img/domestic.c276f1c.png";